import React from 'react'

import {
  RemoveUserElement,
  RemoveUserElementType,
  RemoveUserElementVariables,
} from 'globalTypes'

import { useMutation } from '@apollo/client'
import defaultTo from 'lodash/defaultTo'
import filter from 'lodash/filter'
import flow from 'lodash/flow'
import noop from 'lodash/noop'
import Router from 'next/router'

import MUTATION from './remove-user-element.graphql'

export interface Props {
  children: React.ReactNode
  elementId: string
  elementTypename: string
  type: RemoveUserElementType
  callback?: Function
  [props: string]: any
}

const RemoveElement: React.FC<Props> = ({
  children,
  elementId,
  elementTypename,
  type,
  callback,
  ...props
}: Props): JSX.Element => {
  const [mutate] = useMutation<RemoveUserElement, RemoveUserElementVariables>(
    MUTATION
  )

  const flowOnClick = flow([
    () =>
      mutate({
        variables: { id: elementId, type },
        update(cache) {
          const normalizedId = cache.identify({
            id: elementId,
            __typename: elementTypename,
          })
          cache.evict({ id: normalizedId })
          cache.modify({
            fields: {
              elements(existing = [], { readField }) {
                filter(existing, (ref) => {
                  const _id = readField('id', ref)

                  return typeof _id !== 'undefined' && _id !== elementId
                })
              },
            },
          })
        },
      }),
    defaultTo(callback, noop) as any,
    () => {
      if (window.location.pathname !== '/') {
        Router.push('/')
      }
    },
  ])

  return (
    <button {...props} onClick={flowOnClick}>
      {children}
    </button>
  )
}

export default RemoveElement
